<div class="pt-2" *ngrxLet="docBox$; let docBox">
    <form [formGroup]="docBoxFreeSearchForm">
        <fieldset formArrayName="formChildren" class="d-flex flex-wrap justify-content-between">
            @if (!!model.technicalIdentNo) {
                <div class="row mb-3 col-lg-6 col-12">
                    <label
                        class="col-md-4 col-12 text-start text-md-end col-form-label"
                        for="technicalIdentNo"
                        translate="DASHBOARD_SIDEMENU_DOCBOX_FREE_SEARCH_TECH_IDENT_NUMBER"
                    ></label>
                    <div class="col-lg-8 col-md-7 col-12">
                        <pace-core-text-input
                            id="technicalIdentNo"
                            [(model)]="model.technicalIdentNo"
                            (valueChange)="validateForm()"
                            [parentForm]="formChildren"
                            [ariaLabel]="'DASHBOARD_SIDEMENU_DOCBOX_FREE_SEARCH_TECH_IDENT_NUMBER' | translate"
                        ></pace-core-text-input>
                    </div>
                </div>
            }
            @if (isSearchFormExpanded) {
                <div class="row mb-3 col-lg-6 col-12">
                    <label
                        class="col-md-4 col-12 text-start text-md-end col-form-label"
                        for="functionalLoc"
                        translate="DASHBOARD_SIDEMENU_DOCBOX_FREE_SEARCH_FUNC_LOCATION_NUMBER"
                    ></label>
                    <div class="col-lg-8 col-md-7 col-12">
                        <pace-core-text-input
                            id="functionalLoc"
                            [(model)]="model.functionalLoc"
                            (valueChange)="validateForm()"
                            [parentForm]="formChildren"
                            [ariaLabel]="'DASHBOARD_SIDEMENU_DOCBOX_FREE_SEARCH_FUNC_LOCATION_NUMBER' | translate"
                        ></pace-core-text-input>
                    </div>
                </div>
            }
            @if (isSearchFormExpanded) {
                <div class="row mb-3 col-lg-6 col-12">
                    <label
                        class="col-md-4 col-12 text-start text-md-end col-form-label"
                        for="material"
                        translate="DASHBOARD_SIDEMENU_DOCBOX_FREE_SEARCH_MATERIAL_NUMBER"
                    ></label>
                    <div class="col-lg-8 col-md-7 col-12">
                        <pace-core-text-input
                            id="material"
                            [(model)]="model.material"
                            (valueChange)="validateForm()"
                            [parentForm]="formChildren"
                            [ariaLabel]="'DASHBOARD_SIDEMENU_DOCBOX_FREE_SEARCH_MATERIAL_NUMBER' | translate"
                        ></pace-core-text-input>
                    </div>
                </div>
            }
            @if (isSearchFormExpanded) {
                <div class="row mb-3 col-lg-6 col-12">
                    <label
                        class="col-md-4 col-12 text-start text-md-end col-form-label"
                        for="serialNo"
                        translate="DASHBOARD_SIDEMENU_DOCBOX_FREE_SEARCH_SERIAL_NUMBER"
                    ></label>
                    <div class="col-lg-8 col-md-7 col-12">
                        <pace-core-text-input
                            id="serialNo"
                            [(model)]="model.serialNo"
                            (valueChange)="validateForm()"
                            [parentForm]="formChildren"
                            [ariaLabel]="'DASHBOARD_SIDEMENU_DOCBOX_FREE_SEARCH_SERIAL_NUMBER' | translate"
                        ></pace-core-text-input>
                    </div>
                </div>
            }
            @if (isMobile) {
                <div class="col-12 text-center py-2" (click)="toggleSearchFormExpanded()">
                    <a
                        class="btn-link"
                        [translate]="isSearchFormExpanded ? 'DOCBOX_LESS_OPTIONS' : 'DOCBOX_MORE_OPTIONS'"
                    ></a>
                </div>
            }
        </fieldset>
        <div class="modal-footer justify-content-end p-3">
            <button
                class="btn btn-primary btn-lg me-2"
                type="button"
                (click)="searchDocuments()"
                [disabled]="docBoxFreeSearchForm.invalid"
                translate="DASHBOARD_SIDEMENU_DOCBOX_FREE_SEARCH_BUTTON_SEARCH_LABEL"
            ></button>
        </div>
        @if (docBox.docBoxFiles.length > 0) {
            <pace-forms-docbox [isSideMenuDocbox]="true"></pace-forms-docbox>
        }
        @if (docBox.docBoxFiles.length === 0 && !docBox.isLoading && showErrorMessage) {
            <p class="text-center fs-5">{{ createErrorMessage() }}</p>
        }
        @if (docBox.isLoading) {
            <progressbar [striped]="true" [value]="100" type="default">
                <span translate="DASHBOARD_SIDEMENU_DOCBOX_FREE_LOADING"></span>
            </progressbar>
        }
    </form>
</div>
